import { combineReducers } from "redux";
import homeReducer from "./home-reducer";
import servicesReducer from "./services-reducer";
import galleryReducer from "./gallery-reducer";
import feedbackReducer from "./feedback-reducer";
import contactReducer from "./contact-reducer";

const rootReducer = combineReducers({
  home: homeReducer,
  services: servicesReducer,
  gallery: galleryReducer,
  feedback: feedbackReducer,
  contact: contactReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js